import XIcon from "@heroicons/react/outline/XIcon";
import { Transition } from "@headlessui/react";
import { FC, useState } from "react";

import { Action } from "@interfaces/filters";
import { useFilters } from "@context/filter";

interface Props {
  text: string;
  action: Action;
}

const ExistingFilter: FC<Props> = ({ text, action }) => {
  const { dispatch } = useFilters();
  const [show, setShow] = useState(true);

  return (
    <Transition
      appear={true}
      show={show}
      enter="transition duration-200 origin-top ease-out"
      enterFrom="scale-50 opacity-50"
      enterTo="scale-100 opacity-100"
      leave="transition duration-200 origin-top ease-in"
      leaveFrom="scale-100 opacity-100"
      leaveTo="scale-0 opacity-0"
    >
      <div className="flex flex-row items-center justify-between w-max p-2 m-2 bg-black text-white rounded">
        <div className="text-xs capitalize">{text}</div>
        <XIcon
          onClick={() => {
            setShow(false);
            setTimeout(() => dispatch(action), 200);
          }}
          className="w-4 cursor-pointer"
        />
      </div>
    </Transition>
  );
};

export default ExistingFilter;
